import React, { useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import InsuranceService from '../../../../../../../services/InsuranceService';
import { useUiContext } from '../../../../../../../context/UiContext';

export default function CreateBillButton({ insuranceId, refetch }) {
  const [isPending, setIsPending] = useState(false);

  const { showToast } = useUiContext();

  const { mutate: createNextBill } = useMutation({
    mutationFn: () => {
      setIsPending(true);
      return InsuranceService.createInsuranceBill(insuranceId);
    },
    onSuccess: async () => {
      showToast({
        text: 'Success',
        type: 'success',
      });
      await refetch();
      setIsPending(false);
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
      setIsPending(false);
    },
  });

  return (
    <button
      disabled={isPending}
      onClick={createNextBill}
      className="btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-indigo-500"
      type="button"
    >
      Create Bill
    </button>
  );
}
